import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Image from 'next/image'

import InputField from '@/components/forms/InputField'
import eyeOpenImg from '@/assets/buy-flow/eye-open.svg'
import eyeOffImg from '@/assets/buy-flow/eye-off.svg'

import styles from './PasswordInputField.module.scss'

const PasswordInputField = ({ hide = true, name = 'password', label = 'Password', ...rest }) => {
  const [isHidden, updateIsHidden] = useState(hide)

  const handleInputClick = () => {
    updateIsHidden(!isHidden)
  }

  return (
    <div className={styles.wrapper}>
      <InputField
        className={styles.largeInput}
        data-testid="password-input-field"
        label={label}
        labelProps={{ hidden: true }}
        name={name}
        size="large"
        type={isHidden ? 'password' : 'text'}
        {...rest}
      />
      <div className={styles.toggleHolder} onClick={handleInputClick} role="presentation">
        <Image alt="hide password" className={`${styles.eye} ${!isHidden && styles.hide}`} src={eyeOpenImg} />
        <Image alt="show password" className={`${styles.eye} ${isHidden && styles.hide}`} src={eyeOffImg} />
      </div>
    </div>
  )
}

export default PasswordInputField

PasswordInputField.propTypes = {
  hide: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
}
